import { render, staticRenderFns } from "./el-menu.vue?vue&type=template&id=1d0d4f81&scoped=true&"
import script from "./el-menu.vue?vue&type=script&lang=js&"
export * from "./el-menu.vue?vue&type=script&lang=js&"
import style0 from "./el-menu.vue?vue&type=style&index=0&id=1d0d4f81&prod&lang=scss&"
import style1 from "./el-menu.vue?vue&type=style&index=1&id=1d0d4f81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0d4f81",
  null
  
)

export default component.exports